// extracted by mini-css-extract-plugin
export var active = "Tabs-module--active--9faf8";
export var activeComponent = "Tabs-module--activeComponent--27c51";
export var activeComponentTab = "Tabs-module--activeComponentTab--36bb7";
export var component = "Tabs-module--component--c6ab0";
export var componentTab = "Tabs-module--componentTab--830b4";
export var cyan = "Tabs-module--cyan--45138";
export var next = "Tabs-module--next--6d0f0";
export var red = "Tabs-module--red--f07dc";
export var root = "Tabs-module--root--5560c";
export var share = "Tabs-module--share--d53ad";
export var tab = "Tabs-module--tab--b601c";
export var tabs = "Tabs-module--tabs--d6b7a";